'use strict';
module.exports = require('../../full/object/define-properties');



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/features/object/define-properties.js
// module id = 605
// module chunks = 13